import {
  GetActivityProductsQuery,
  GetActivityProductsQueryVariables,
} from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { GET_ACTIVITY_PRODUCTS } from '@dustin-web/microsite-data/src/graphql/product/get-activity-products.graphql'
import { ProductCardGallerySwitch } from '../cards'
import React from 'react'
import { Spinner } from '@dustin-web/microsite-components/src/spinner'
import { useGraphql } from '@dustin-web/microsite-data/src/hooks'
import { DigitalDataOrigin } from '../utils/digital-data-types'
import { useResponsive } from '@dustin-web/microsite-components/src/hooks'

type Props = {
  activityId: number
  digitalDataOrigin: DigitalDataOrigin
}

export const ActivityProducts = ({ activityId, digitalDataOrigin }: Props) => {
  const { breakpoints } = useResponsive()
  const { data, isValidating: loading } = useGraphql<
    GetActivityProductsQuery,
    GetActivityProductsQueryVariables
  >(GET_ACTIVITY_PRODUCTS, {
    variables: {
      activityId,
    },
  })

  const products = data?.activity?.products

  if (loading) {
    return (
      <div className="u-pt-96" style={{ minHeight: '300px' }}>
        <Spinner local size="md" />
      </div>
    )
  }

  if (!products) {
    return null
  }

  return (
    <div className="row sm-gutters">
      {products.map((product, i) => (
        <ProductCardGallerySwitch
          ticket={''}
          showSideButtons={breakpoints.max.SM}
          showFavoritesButton={true}
          showActionRow={true}
          product={product}
          key={i}
          imagePriority={i < 4}
          digitalDataOrigin={digitalDataOrigin}
          digitalIndex={i}
        />
      ))}
    </div>
  )
}
